<template>
  <div class="home">
    <header>
      <div class="head">
        <div class="hleft">
          <div class="logo">
            <img src="../../assets/logo.png" alt />
            <div class="cTitle">
              <h2>北京天蔚中医药发展促进中心</h2>
              <h4>BeijingTianweiPromotionCenter</h4>
            </div>
          </div>
        </div>
        <!-- <div class="hright">
          <h3 @click="$router.push('/pmain')">返回主站</h3>
        </div>-->
      </div>
    </header>
    <div class="center">
      <div class="cleft">
        <div class="txlogo">
          <el-upload
            class="avatar-uploader"
            action="http://123.56.170.62:9999/tianwei/updhead"
            ref="pictUpload"
            :show-file-list="false"
            list-type="picture-card"
            :on-change="picthandleChange"
            :before-upload="pictbeforeAvatarUpload"
            :auto-upload="true"
            :on-success="successRun"
            :data="{ phone: userInfo.phone }"
          >
            <img v-if="userInfo.head" :src="userInfo.head" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <h4>{{ userInfo.name }}</h4>
        <div class="nav">
          <div
            @click="chang(item, index)"
            :class="index == currentIndex ? 'item selected' : 'item'"
            v-for="(item, index) in nav"
            :key="item.title"
          >
            <i :class="item.icon"></i>
            <h3>{{ item.title }}</h3>
          </div>
        </div>
      </div>
      <div class="cright">
        <div class="content">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus.js"
import { Login, getReCode, getBackCode } from "@/api/user.js"
export default {
  name: "Home",
  data() {
    return {
      userInfo: {},
      nav: [
        { title: "个人信息", icon: "iconfont icon-yonghu", url: "/userInfo" },
        {
          title: "我的项目",
          icon: "iconfont icon-iconzhengli_xiangmu",
          url: "/pmyProgram",
        },
        { title: "返回首页", icon: "iconfont icon-gongneng", url: "/" },
        { title: "退出登录", icon: "iconfont icon-yunzhuomian", url: "/" },
      ],
      currentIndex: 0,
    }
  },
  mounted() {
    this.getCurrent()
    Bus.$on("getCmsCurrent", (e) => {
      this.getCurrent(e)
    })
    this.userInfo = this.$store.state.user.userInfo
  },
  methods: {
    // 检查是否被选中
    getCurrent(currentUrl) {
      this.nav.forEach((item, index) => {
        if (item.url == window.location.pathname || item.url == currentUrl) {
          this.currentIndex = index
          return false
        }
      })
    },
    chang(item, index) {
      if (index == 3) {
        this.$confirm(`确认退出吗？`, "确认信息", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确认退出",
          cancelButtonText: "取消退出",
        })
          .then(async () => {
            this.logout()
            this.$router.push(item.url)
            this.currentIndex = index
          })
          .catch((action) => {
            this.$message({
              type: "info",
              message: "已取消退出",
            })
          })
      } else {
        this.$router.push(item.url)
        this.currentIndex = index
      }
    },
    //退出登录
    logout() {
      // 清除token
      localStorage.removeItem("Token")
      this.$store.commit("user/getUserInfo", {})
      this.userInfo = this.$store.state.user.userInfo
      // // 页面跳转
      // this.getCookie();
    },
    pictbeforeAvatarUpload(file) {
      return new Promise((resolve, reject) => {
        resolve()
      })
    },
    successRun(response, file, fileListfile) {
      if (response.code == "OK") {
        this.$store.commit("user/getUserInfo", response.user)
        this.$message.success("修改成功")
      } else {
        this.$message.error(response.msg)
      }
    },
    picthandleChange(file, fileList) {
      const isJPG =
        file.raw.type == "image/png" ||
        file.raw.type == "image/jpg" ||
        file.raw.type == "image/jpeg"
      const isLt2M = file.raw.size / 1024 / 1024 < 10
      if (!isJPG) {
        this.$message.error("图片只能是 png/jpg/jpeg 格式!")
      }
      if (!isLt2M) {
        this.$message.error("图片不能超过 10MB!")
      }
      if (!isJPG || !isLt2M) {
      } else {
        this.userInfo.head = URL.createObjectURL(file.raw)
      }
    },
  },
  components: {},
}
</script>

<style lang="less" scoped>
@color: #512475;
#open {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease-in-out;
  z-index: 95;
}

.info {
  margin-left: 30px;
  line-height: 2;

  h2 {
    font-size: 16px;
    color: #333333;
    font-weight: bold;
  }

  p {
    font-size: 14px;
    color: #666;
  }

  .line {
    width: 130px;
    height: 2px;
    margin-left: -20px;
    background-color: #555;
  }
}

.home {
  width: 100%;
  header {
    height: 70px;
    width: 100%;
    box-shadow: 2px 2px 10px #aaa;
    .head {
      display: flex;
      justify-content: space-between;
      .hleft {
        width: 300px;
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        background-color: #fff;
        .logo {
          margin-right: 15px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          img {
            width: 44px;
            height: 44px;
          }
          .cTitle {
            margin-left: 4px;
            h2 {
              font-size: 14px;
              font-weight: bolder;
              margin-bottom: 4px;
            }
            h4 {
              font-size: 11px;
            }
          }
        }
      }
      .hright {
        margin-right: 40px;
        h3 {
          font-size: 16px;
          line-height: 70px;
          cursor: pointer;
        }
      }
    }
  }
  .center {
    display: flex;
    width: 100%;
    height: 100%;
    background-color: #fafafa;
    .cleft {
      width: 180px;
      height: cacla(100vh - 70px);
      background-color: #fff;
      text-align: center;
      .txlogo {
        margin-top: 40px;
        /deep/ .el-upload--picture-card {
          width: 80px;
          height: 80px;
          border: none;
        }
        .avatar {
          width: 80px;
          height: 80px;
          border-radius: 50%;
        }
      }
      h4 {
        margin: 20px 0 50px;
        font-size: 16px;
        color: #aaa;
      }
      .nav {
        .item {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 60px;
          font-size: 16px;
          cursor: pointer;
          i {
            margin-right: 10px;
            font-size: 20px;
          }
        }
        .selected {
          background-color: #0687c8;
          color: #fff;
        }
      }
    }
    .cright {
      flex: 1;
      padding-left: 230px;
      margin-top: 20px;
      background-color: #fafafa;
      .content {
        width: 740px;
        background-color: #fff;
      }
    }
  }
}
</style>
